/* Modern Roots: observe successful single-item adds; never change the original add request. */
(() => {
  'use strict';
  if (window.MRDuoUpsell || !window.HTMLDialogElement) return;
  const configNode = document.getElementById('mr-duo-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  window.MRDuoUpsell = { version: '2.0.0' };
  const copies = {"balm": {"name": "Soothe It & Move It Duo", "products": "Balm of Gilead + Lymphatic Motion Body Lotion", "badge": "Best seller", "description": "You're already easing the ache, might as well help your body finish the job. Add our Lymphatic Motion Lotion to your Balm of Gilead Anti-Inflammatory Magnesium Whip and give your routine a full soothe-and-move boost: deep, tension-melting relief for tired muscles and achy joints, followed by lymphatic stimulation that helps drain toxins and get things flowing again. Better together, and priced as a bundle for a limited time."}, "glow": {"name": "Brighten & Glow Duo", "products": "Cranberry Toner + Kojic Cherry Exfoliating Cleansing Pads", "badge": "Limited time bundle", "description": "Bring out your best glow with this hydrating, brightening duo made for radiant skin. Featuring our Cranberry Toner, a plumping blend of triple molecular weight hyaluronic acid, cranberry extract, and fresh-pressed cranberry juice, paired with our Kojic Cherry Exfoliating Cleansing Pads, a gentle glow-boosting treatment infused with kojic acid, azelaic acid, and antioxidant-rich wild cherry oil to fade hyperpigmentation and dark spots. A beautiful gift to give, or a nightly ritual to stash for yourself all year long. Available for a limited time as a bundle offer."}};
  const offers = config.offers || [{kind:'balm', variants:config.balmVariants, duoHandle:config.duoHandle, sourceName:'Balm of Gilead', singleName:'balm'}];
  const root = config.root.replace(/\/?$/, '/');
  const originalFetch = window.fetch.bind(window);
  const ready = document.readyState === 'loading' ? new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true })) : Promise.resolve();
  let active = false, busy = false, dialog, offer, priorFocus, finishOffer;
  let dismissed = false;
  const pendingKey = 'mr-duo-pending-v1';
  function clearPending() { try { sessionStorage.removeItem(pendingKey); } catch (_) {} }
  function savePending(items, result) {
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ items, result, at: Date.now() })); } catch (_) {}
  }
  const endpoint = path => root + path;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || config.currency || 'USD' }).format(cents / 100);
  const isAdd = url => {
    try { const u = new URL(url, location.href); return u.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(u.pathname); } catch (_) { return false; }
  };
  function requestedItems(body) {
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        if (body.has('id')) return [{ id: body.get('id'), quantity: body.get('quantity') || 1, selling_plan: body.get('selling_plan') }];
        const items = [];
        for (const [key, value] of body.entries()) {
          const match = key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);
          if (match) (items[Number(match[1])] ||= {})[match[2]] = value;
        }
        return items.filter(Boolean);
      }
      if (typeof body === 'string') {
        try { const data = JSON.parse(body); return data.items || [data]; }
        catch (_) { return requestedItems(new URLSearchParams(body)); }
      }
    } catch (_) { /* Unsupported request bodies are left alone. */ }
    return [];
  }
  const matchOffer = items => items.length === 1 && Number(items[0].quantity ?? 1) === 1 && !items[0].selling_plan && offers.find(o => (o.variants || []).includes(Number(items[0].id)));
  const eligible = items => Boolean(matchOffer(items));
  const containsDuo = (cart, ids) => cart.items.some(i => ids.includes(Number(i.variant_id || i.id)) && i.quantity > 0);
  async function read(path) {
    const response = await originalFetch(endpoint(path), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not read the current cart.');
    return response.json();
  }
  async function post(path, data) {
    const response = await originalFetch(endpoint(path), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'The cart could not be updated.');
    return result;
  }
  function buildDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.id = 'mr-duo-dialog';
    dialog.setAttribute('aria-labelledby', 'mr-duo-title');
    dialog.setAttribute('aria-describedby', 'mr-duo-description');
    dialog.innerHTML = `<button class="mr-duo-close" type="button" aria-label="Keep my balm and close offer">×</button>
      <div class="mr-duo-layout"><div class="mr-duo-visual"><span class="mr-duo-badge">Best seller</span><img alt="Soothe It & Move It Duo" width="1000" height="1250"></div>
      <div class="mr-duo-copy"><p class="mr-duo-eyebrow"><span class="mr-duo-brand" aria-label="ModernRoots"><span>M</span>ODERN<span>R</span>OOTS</span> · A little more care</p>
      <h2 id="mr-duo-title">Better together.</h2>
      <p class="mr-duo-name">Soothe It &amp; Move It Duo</p>
      <p class="mr-duo-products">Balm of Gilead + Lymphatic Motion Body Lotion</p>
      <p id="mr-duo-description" class="mr-duo-detail">You're already easing the ache, might as well help your body finish the job. Add our Lymphatic Motion Lotion to your Balm of Gilead Anti-Inflammatory Magnesium Whip and give your routine a full soothe-and-move boost: deep, tension-melting relief for tired muscles and achy joints, followed by lymphatic stimulation that helps drain toxins and get things flowing again. Better together, and priced as a bundle for a limited time.</p>
      <div class="mr-duo-price"><s class="mr-duo-original" aria-label="Original price"></s><strong class="mr-duo-sale" aria-label="Offer price"></strong><span class="mr-duo-savings"></span></div>
      <p class="mr-duo-replace">We’ll replace <strong>one Balm of Gilead</strong> in your cart with <strong>one duo.</strong></p>
      <button class="mr-duo-accept" type="button">Add Duo To Cart</button>
      <button class="mr-duo-decline" type="button">No thanks, keep my single balm</button>
      <p class="mr-duo-status" role="status" aria-live="polite"></p>
      <a class="mr-duo-cart" hidden>Review my cart</a></div></div>`;
    document.body.append(dialog);
    let lastWidth = 0;
    new ResizeObserver(() => { const width = dialog.querySelector('.mr-duo-products').clientWidth; if (width !== lastWidth) { lastWidth = width; fitProductLine(); } }).observe(dialog.querySelector('.mr-duo-products'));
    dialog.querySelector('.mr-duo-cart').href = endpoint('cart');
    dialog.querySelector('.mr-duo-accept').addEventListener('click', accept);
    dialog.querySelector('.mr-duo-decline').addEventListener('click', close);
    dialog.querySelector('.mr-duo-close').addEventListener('click', close);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    // Keep app-level document click handlers from dismissing this independent offer.
    dialog.addEventListener('click', event => event.stopPropagation());
    dialog.addEventListener('keydown', event => event.stopPropagation());
    dialog.addEventListener('close', () => {
      if (!dismissed) {
        // Some cart apps close all dialogs after adding a product.
        requestAnimationFrame(() => { if (active && dialog.isConnected && !dialog.open) dialog.showModal(); });
        return;
      }
      active = false;
      if (priorFocus?.isConnected) priorFocus.focus();
      finishOffer?.();
      finishOffer = null;
    });
  }
  function fitProductLine() {
    if (!dialog?.open) return;
    const line = dialog.querySelector('.mr-duo-products');
    if (dialog.dataset.offerKind !== 'glow') { line.style.fontSize = ''; return; }
    if (!line.clientWidth) return;
    line.style.fontSize = '16px';
    const range = document.createRange();
    range.selectNodeContents(line);
    const width = range.getBoundingClientRect().width;
    if (width) line.style.fontSize = `${Math.floor(16 * (line.clientWidth - 1) / width * 100) / 100}px`;
  }
  function close() {
    if (busy) return;
    dismissed = true;
    clearPending();
    dialog.close();
  }

  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('button').forEach(button => { button.disabled = value; });
    dialog.querySelector('.mr-duo-accept').textContent = value ? 'Updating your cart…' : 'Add Duo To Cart';
  }
  async function onAdded(items, result) {
    if (active || !eligible(items) || result.status) return;
    const line = (result.items || [result]).find(item => Number(item.variant_id || item.id) === Number(items[0].id));
    if (!line?.key || line.selling_plan_allocation) return;
    const selected = matchOffer(items);
    active = true;
    dismissed = false;
    // Save before any async work: an app may navigate as soon as the add completes.
    savePending(items, result);
    try {
      await ready;
      const [product, cart] = await Promise.all([read(`products/${selected.duoHandle}.js`), read('cart.js')]);
      const variant = product.variants.find(v => v.available);
      const current = cart.items.find(i => i.key === line.key);
      if (containsDuo(cart, product.variants.map(v => Number(v.id))) || !variant || !current || current.quantity < 1 || current.selling_plan_allocation || product.requires_selling_plan || product.variants.length !== 1) { active = false; clearPending(); return; }
      offer = { key: line.key, quantity: current.quantity, variant: variant.id, price: variant.price, selected, duoVariants: product.variants.map(v => Number(v.id)) };
      buildDialog();
      const copy = copies[selected.kind];
      dialog.dataset.offerKind = selected.kind;
      dialog.querySelector('.mr-duo-name').textContent = copy.name;
      dialog.querySelector('.mr-duo-products').textContent = copy.products;
      dialog.querySelector('.mr-duo-badge').textContent = copy.badge;
      dialog.querySelector('#mr-duo-description').textContent = copy.description;
      dialog.querySelector('img').alt = copy.name;
      dialog.querySelector('.mr-duo-replace strong').textContent = 'one ' + selected.sourceName;
      dialog.querySelector('.mr-duo-close').setAttribute('aria-label', 'Keep my ' + selected.singleName + ' and close offer');
      dialog.querySelector('img').src = new URL(product.featured_image || product.images[0], 'https://' + (location.host || 'modernroots.org')).href;
      const comparison = Number(variant.compare_at_price || 0);
      const savings = comparison - variant.price;
      dialog.querySelector('.mr-duo-original').hidden = savings <= 0;
      dialog.querySelector('.mr-duo-original').textContent = money(comparison, cart.currency);
      dialog.querySelector('.mr-duo-sale').textContent = money(offer.price, cart.currency);
      dialog.querySelector('.mr-duo-savings').hidden = savings <= 0;
      dialog.querySelector('.mr-duo-savings').textContent = savings === 500 && cart.currency === 'USD' ? 'Save $5' : `Save ${money(savings, cart.currency)}`;
      dialog.querySelector('.mr-duo-status').textContent = '';
      dialog.querySelector('.mr-duo-decline').textContent = 'No thanks, keep my single ' + selected.singleName;
      dialog.querySelector('.mr-duo-cart').hidden = true;
      setBusy(false);
      priorFocus = document.activeElement;
      const decision = new Promise(resolve => { finishOffer = resolve; });
      dialog.showModal();
      fitProductLine();
      document.fonts?.ready.then(fitProductLine);
      return decision;
    } catch (_) { active = false; clearPending(); /* An optional offer must never break the original purchase. */ }
  }
  async function accept() {
    if (busy) return;
    setBusy(true);
    const status = dialog.querySelector('.mr-duo-status');
    status.textContent = '';
    let token, originalQuantity, attemptedAdd = false, attemptedRemoval = false;
    try {
      const cart = await read('cart.js');
      if (containsDuo(cart, offer.duoVariants)) throw new Error('This duo is already in your cart. Your single item has been kept.');
      const balm = cart.items.find(item => item.key === offer.key);
      if (!balm || balm.quantity !== offer.quantity) throw new Error('Your cart changed. Please review your cart before replacing the item.');
      originalQuantity = balm.quantity;
      token = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      // A private property isolates this one duo for safe rollback, including an existing duo in cart.
      attemptedAdd = true;
      await post('cart/add.js', { items: [{ id: offer.variant, quantity: 1, properties: { _mr_duo_swap: token } }] });
      const afterAdd = await read('cart.js');
      if (afterAdd.items.some(i => offer.duoVariants.includes(Number(i.variant_id || i.id)) && i.properties?._mr_duo_swap !== token && i.quantity > 0)) throw new Error('This duo was already added to your cart.');
      const stillBalm = afterAdd.items.find(item => item.key === offer.key);
      if (!stillBalm || stillBalm.quantity !== originalQuantity) throw new Error('Your cart changed during the update.');
      attemptedRemoval = true;
      await post('cart/change.js', { id: offer.key, quantity: originalQuantity - 1 });
      clearPending();
      location.assign(endpoint('cart'));
      return;
    } catch (error) {
      let message = error.message;
      if (attemptedAdd) {
        try {
          // Reconcile ambiguous network failures before deciding whether to undo the added duo.
          const cart = await read('cart.js');
          const balm = cart.items.find(item => item.key === offer.key);
          const duo = cart.items.find(item => item.properties?._mr_duo_swap === token);
          const remaining = balm?.quantity || 0;
          if (attemptedRemoval && duo && remaining === originalQuantity - 1) { clearPending(); location.assign(endpoint('cart')); return; }
          if (remaining === originalQuantity) {
            if (duo) await post('cart/change.js', { id: duo.key, quantity: 0 });
            message = 'We couldn’t complete the replacement. Your original item is still in your cart. Please review your cart.';
          } else {
            message = 'Your cart changed during the update. Please review your cart before checking out.';
          }
        } catch (_) { message = 'We couldn’t confirm the cart update. Please review your cart before checking out.'; }
      }
      setBusy(false);
      // No automatic retry: a connection failure may already have committed a cart mutation.
      dialog.querySelector('.mr-duo-accept').disabled = true;
      dialog.querySelector('.mr-duo-cart').hidden = false;
      dialog.querySelector('.mr-duo-decline').textContent = 'Close offer';
      status.textContent = message;
    }
  }
  // Installed before theme and app scripts, covering theme quick-add and GemPages AJAX forms.
  window.fetch = function(input, init) {
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    const method = init?.method || (input instanceof Request ? input.method : 'GET');
    if (!isAdd(url) || method.toUpperCase() !== 'POST') return originalFetch(input, init);
    const body = init?.body !== undefined ? Promise.resolve(init.body) : input instanceof Request ? input.clone().text() : Promise.resolve(null);
    return originalFetch(input, init).then(async response => {
      if (response.ok) {
        try {
          const [b, data] = await Promise.all([body, response.clone().json()]);
          await onAdded(requestedItems(b), data);
        } catch (_) { /* Preserve the original add response if the optional offer fails. */ }
      }
      return response;
    });
  };
  // Resume after an app-triggered cart navigation or reload. Explicit choices clear this record.
  ready.then(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!saved) return;
      if (Date.now() - saved.at > 5 * 60 * 1000) { clearPending(); return; }
      onAdded(saved.items, saved.result);
    } catch (_) { clearPending(); }
  });
  const xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._mrDuoAdd = String(method).toUpperCase() === 'POST' && isAdd(url);
    return xhrOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (this._mrDuoAdd) {
      const items = requestedItems(body);
      if (eligible(items)) this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) {
          try { onAdded(items, this.responseType === 'json' ? this.response : JSON.parse(this.responseText)); } catch (_) {}
        }
      }, { once: true });
    }
    return xhrSend.call(this, body);
  };
})();
